<template>
  <el-dialog
      v-el-drag-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      :title="warehousePreRegistration.id ? '编辑' : '新增'"
      width="1400px"
      top="2vh"
      class="warehouse-pre-registration-edit-dialog"
      @close="warehousePreRegistration = warehousePreRegistrationBackup">
    <div v-loading="contentLoading">
      <div class="title">基本信息</div>
      <el-form ref="warehousePreRegistrationForm" :model="warehousePreRegistration" :rules="rules" label-width="140px">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="发起人">
              <el-input v-model="warehousePreRegistration.creatorName" placeholder="请输入发起人"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="发起时间">
              <el-date-picker
                  v-model="warehousePreRegistration.creatTime"
                  type="datetime"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择发起时间"
                  style="width: 100%"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="快递公司" prop="courierCompany">
              <el-input v-model="warehousePreRegistration.courierCompany" placeholder="请输入快递公司"/>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item label="快递单号" prop="courierNo">
              <el-input v-model="warehousePreRegistration.courierNo" placeholder="请输入快递单号"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户名称">
              <el-input v-model="warehousePreRegistration.customerName" readonly placeholder="请输入" clearable>
                <el-button
                    slot="append"
                    icon="el-icon-search"
                    style="margin-left: 2%;"
                    @click="$refs.selectCustomer.open()">
                  选择
                </el-button>
              </el-input>
              <customer-select ref="selectCustomer" @select="selectCustomer"/>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="关联售后单号" prop="associationNo">
              <el-input v-model="warehousePreRegistration.associationNo" placeholder="请输入流程号"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      
      <div class="title">
        明细信息
        <el-button type="primary" style="margin-left: 10px;" @click="addDetail">添加物料</el-button>
      </div>
      <el-table
          ref="elTable"
          :data="warehousePreRegistration.details"
          border>
        <el-table-column type="index" align="center" label="行号" width="60"/>
        <el-table-column label="物料类型" width="120" align="center">
          <template slot-scope="scope">
            <el-select v-model="scope.row.materialType" placeholder="请选择物料类型" clearable>
              <el-option label="驱动" value="5"/>
              <el-option label="卡器" value="1"/>
              <el-option label="电机" value="2"/>
              <el-option label="线材" value="3"/>
              <el-option label="配件" value="4"/>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column prop="materialSn" width="160" align="center" label="条形码">
          <template slot-scope="scope">
            <el-input
                v-model="scope.row.materialSn"
                autosize
                type="textarea"
                placeholder="请输入"
                @keyup.enter.native="getProcess(scope.row)"/>
          </template>
        </el-table-column>
        <el-table-column label="物料编码" width="160" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.materialNo" placeholder="请输入物料编码"/>
          </template>
        </el-table-column>
        <el-table-column label="物料名称" width="160" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.materialName" placeholder="请输入物料名称"/>
          </template>
        </el-table-column>
        <el-table-column label="规格型号" width="160" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.specifications" placeholder="请输入规格型号"/>
          </template>
        </el-table-column>
        <el-table-column label="退货数量" width="100" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.quantity"/>
          </template>
        </el-table-column>
        <el-table-column label="实到数量" width="120" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.actualQuantity"/>
          </template>
        </el-table-column>
        <el-table-column label="实际到货时间" width="160" align="center">
          <template slot-scope="scope">
            <el-date-picker
                v-model="scope.row.actualDeliverTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择时间"
                style="width: 100%"/>
          </template>
        </el-table-column>
        <el-table-column label="返厂单号" width="180" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.returnBillNo" placeholder="请输入返厂单号"/>
          </template>
        </el-table-column>
        <el-table-column label="初步判责" width="180" align="center">
          <template slot-scope="scope">
            <el-input v-model="scope.row.initDuty" placeholder="请输入初步判责"/>
          </template>
        </el-table-column>
        <el-table-column label="仓库编号" width="160" align="center">
          <template slot-scope="scope">
            <el-select
                v-model="scope.row.locationNo"
                placeholder="请选择"
                @change="$set(model.details, scope.$index, scope.row)">
              <el-option
                  v-for="item in constants.locationNo.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column
            label="操作"
            align="center"
            width="100"
            fixed="right">
          <template v-slot="scope">
            <el-button type="danger" @click="deleteDetail(scope.$index)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <div>
        <div
            style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
          附件信息
        </div>
        <div
            style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;margin: 10px 0 10px 0">
          <upload-file
              ref="upload"
              :auth-index="authIndex"
              style="margin-bottom: 10px; float: left"
              @upload-success="uploadSuccess"/>
        </div>
        <el-table
            ref="payData1"
            :data="warehousePreRegistration.attachments">
          <el-table-column type="index" align="center" label="行号"/>
          <el-table-column prop="fileName" align="center" label="图片">
            <template slot-scope="scope">
              <el-image
                  style="width: 50px; height: 50px;margin-right: 10px"
                  :src="scope.row.imgUrl"
                  :preview-src-list="imgUrls"/>
            </template>
          </el-table-column>
          <el-table-column prop="fileName" align="center" label="附件描述">
            <template slot-scope="scope">
              <el-input
                  v-model="scope.row.fileName"
                  class="tabInput"
                  style="width: 400px;margin: 0 auto;text-align: center"/>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
            <template slot-scope="scope">
              <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button :loading="submitLoading" type="primary" @click="handleSubmit">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import UploadFile from "@/components/UploadFile";
  import constants from "@/util/constants";
  import auth from "@/util/loginUtil";
  export default {
    name: "WarehousePreRegistrationEdit",
    components: {UploadFile, CustomerSelect},
    data() {
      return {
        constants,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        authIndex: 700,
        imgUrls: [],
        files: [],
        fileList: [],
        warehousePreRegistrationBackup: {},
        warehousePreRegistration: {
          id: "",
          billNo: "",
          creatorName: auth.getName(),
          createTime: "",
          associationNo: "",
          expressCompany: "",
          expressNo: "",
          customerName: "",
          details: [],
          attachments: [],
        },
        rules: {
          customerName: [
            { required: true, message: "请输入客户名称", trigger: "blur" },
          ],
          expressCompany: [
            { required: true, message: "请输入快递公司", trigger: "blur" },
          ],
          expressNo: [
            { required: true, message: "请输入快递单号", trigger: "blur" },
          ],
        },
      };
    },
    methods: {
      open(row) {
        console.log("open - row:", row);
        this.dialogVisible = true;
        if (row && row.pkid) {
          this.getData(row.pkid);
        } else {
          // 新增时设置默认值
          this.warehousePreRegistration = {
            id: "",
            billNo: "",
            creatorName: this.$store.getters.userInfo.name || "",
            createTime: this.formatDateTime(new Date()),
            associationNo: "",
            expressCompany: "",
            expressNo: "",
            customerName: "",
            details: [],
          };
        }
        this.warehousePreRegistrationBackup = JSON.parse(JSON.stringify(this.warehousePreRegistration));
        
      },
      formatDateTime(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },
      getData(id) {
        this.contentLoading = true;
        this.$http.get("basic", `warehouseRegisters/${id}`).then(res => {
          if (res.success) {
            this.warehousePreRegistration = res.data;
            // 确保details数组存在
            if (!this.warehousePreRegistration.details) {
              this.warehousePreRegistration.details = [];
            }
            // 处理附件
            if (this.warehousePreRegistration.attachments && this.warehousePreRegistration.attachments.length > 0) {
              this.warehousePreRegistration.attachments.forEach(row => {
                this.$http.get("basic", `files/getDownloadUrl?key=${row.filePath}`).then((res) => {
                  if (res.success) {
                    row.imgUrl = res.data;
                    this.imgUrls.push(row.imgUrl);
                  }
                });
              });
            }
          }
        }).finally(() => {
          this.contentLoading = false;
        });
      },
      addDetail() {
        this.warehousePreRegistration.details.push({
          type: "",
          materialNo: "",
          specifications: "",
          returnQuantity: 0,
          snNo: "",
          actualArrivalTime: "",
          actualQuantity: 0,
          mesProcessNo: "",
          preliminaryReason: "",
          preliminaryWarehouseLocation: "",
        });
      },
      deleteDetail(index) {
        this.warehousePreRegistration.details.splice(index, 1);
      },
      selectCustomer(row) {
        this.warehousePreRegistration.customerName = row.customerName;
        this.warehousePreRegistration.customerId = row.customerID;
      },
      getProcess(row) {
        if (row.materialSn) {
          let params = {
            sn: row.materialSn,
          };
          this.$http.get("basic", "snSerialNos/getVoBySn", params).then((res) => {
            console.log(res.data);
            row.materialNo = res.data.materialNo;
            row.specifications = res.data.specification;
            row.materialName = res.data.materialDescription;
          }).catch(() => {
            this.$message.error("未查询到条码对应的物料");
          });
        }

      },
      handleSubmit() {
        this.$refs.warehousePreRegistrationForm.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            const url = "warehouseRegisters";
            const method = this.warehousePreRegistration.pkid ? "put" : "post";
            
            this.$http[method]("basic", url, this.warehousePreRegistration)
              .then(() => {
                this.$emit("save-success");
                this.$message.success(this.warehousePreRegistration.pkid ? "编辑成功" : "新增成功");
                this.dialogVisible = false;
              })
              .finally(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      uploadSuccess(fileList) {
        if (fileList.length) {
          const params = {
            fileName: fileList[0].name,
            filePath: fileList[0].key,
          };
          this.warehousePreRegistration.attachments.push(params);
        }
      },
      fileDelete(row, index) {
        this.warehousePreRegistration.attachments.splice(index, 1);
      },
    },
  };
</script>

<style lang="scss" scoped>
.title {
  font-size: 16px;
  font-weight: bold;
  margin: 15px 0 10px 0;
  padding-bottom: 5px;
  border-bottom: 1px solid #dfe6ec;
}
.warehouse-pre-registration-edit-dialog {
  ::v-deep .el-dialog{
    height: 88vh;
    .el-dialog__body{
      height: 100%;
      background-color: #fff;
    }
    .el-dialog__footer{
      background-color: #fff;
    }
  }
}
</style>